import { brandIdentity } from "./brand";

export const techniaSocialLinks = [
  {
    id: "linkedin",
    name: "LinkedIn",
    label: "LinkedIn TechniaHQRobot",
    shortLabel: "LinkedIn",
    handle: "TechniaHQRobot",
    url: "https://www.linkedin.com/in/techniahqrobot",
    description: "Professional robotics updates and industry coverage",
  },
  {
    id: "x",
    name: "X",
    label: `X ${brandIdentity.social.x.handle}`,
    shortLabel: "X",
    handle: brandIdentity.social.x.handle,
    url: brandIdentity.social.x.visibleUrl,
    description: "Daily robotics news",
  },
  {
    id: "instagram",
    name: "Instagram",
    label: `Instagram ${brandIdentity.social.instagram.handle}`,
    shortLabel: "Instagram",
    handle: brandIdentity.social.instagram.handle,
    url: brandIdentity.social.instagram.visibleUrl,
    description: "Humanoid robot clips and visual explainers",
  },
  {
    id: "tiktok",
    name: "TikTok",
    label: `TikTok ${brandIdentity.social.tiktok.handle}`,
    shortLabel: "TikTok",
    handle: brandIdentity.social.tiktok.handle,
    url: brandIdentity.social.tiktok.visibleUrl,
    description: "Short robotics demonstrations",
  },
  {
    id: "youtube",
    name: "YouTube",
    label: "YouTube TechniaHQRobot",
    shortLabel: "YouTube",
    handle: brandIdentity.social.youtube.handle,
    url: brandIdentity.social.youtube.visibleUrl,
    description: "Robot videos and explainers",
  },
  {
    id: "facebook",
    name: "Facebook",
    label: "Facebook TechniaHQRobot",
    shortLabel: "Facebook",
    handle: brandIdentity.social.facebook.handle,
    url: brandIdentity.social.facebook.visibleUrl,
    description: "Robotics updates and discussions",
  },
  {
    id: "threads",
    name: "Threads",
    label: "Threads TechniaHQRobot",
    shortLabel: "Threads",
    handle: "@techniahqrobot",
    url: "https://www.threads.com/@techniahqrobot",
    description: "Robotics posts and discussion",
  },
  {
    id: "bilibili",
    name: "Bilibili",
    label: "Bilibili TechniaHQRobot",
    shortLabel: "Bilibili",
    handle: "TechniaHQRobot",
    url: "https://space.bilibili.com/3745019471072360",
    description: "Robotics video coverage for Bilibili",
  },
];

const socialLinksById = Object.fromEntries(techniaSocialLinks.map((link) => [link.id, link]));

export const socialLinks = [
  socialLinksById.linkedin,
  socialLinksById.x,
  socialLinksById.instagram,
  socialLinksById.tiktok,
  socialLinksById.youtube,
  socialLinksById.facebook,
  socialLinksById.threads,
  socialLinksById.bilibili,
  {
    id: "support",
    label: "Support TechniaHQRobot",
    shortLabel: "Support",
    url: "https://www.paypal.com/paypalme/techniahq/1USD",
    description: "Support independent robotics media and future robotics explainers.",
  },
];
